// File Metadata:
// Filename: Home.js
// Version: 1.00
// Created: 2022-08-23 18:50:16
// Last Modified: 2025-04-01 17:27:27
// Authors: [Your Name]
// Description: A brief summary of what this file does

import React, { useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectCurrentToken } from '../features/auth/authSlice'
import Login from '../features/auth/Login'
import './Home.css'
import useAuth from '../hooks/useAuth'

const Home = () => {
    const token = useSelector(selectCurrentToken)
    const navigate = useNavigate()

    useEffect(() => {
        if (token) {
            navigate('/dash')
        }
    }, [token, navigate])

    return <Login />
}

export default Home
